import { useMemo } from "react";
import { useCatalog } from "@/data/CatalogContext";
import { useProductRegistry } from "@/data/ProductRegistryContext";
import { computeMaterialDeltas, type MaterialDelta } from "@/data/skuMapping";
import type { ProjectConfiguration } from "@/data/types";

export function useMaterialDeltas(
  baselineConfig: ProjectConfiguration | null | undefined,
  currentConfig: ProjectConfiguration | null | undefined
): MaterialDelta[] {
  const { skuCatalog, mappingRules } = useCatalog();
  const { products: registryProducts } = useProductRegistry();

  return useMemo(() => {
    if (!baselineConfig || !currentConfig) return [];
    return computeMaterialDeltas(baselineConfig, currentConfig, skuCatalog, registryProducts, mappingRules);
  }, [baselineConfig, currentConfig, skuCatalog, registryProducts, mappingRules]);
}
